module.exports = __webpack_public_path__ + "img/down-nx3.d141995b.jpg";